import React, { Component } from "react";
import { Field } from "formik";
import axiosInstance from "../../../axios-project";

class SelectionFields extends Component {
  state = {
    options: []
  };

  componentDidMount(prevProps, prevState, snapshot) {
    axiosInstance
      .get(`${this.props.url}`)
      .then(response => {
          var data = [...response.data];
          if (this.props.finalizeData) {
              data = this.props.finalizeData(data);
          }
        this.setState(prevState => {
          return {
            options: data
          };
        });
      })
      .catch(error => {
        console.log(error);
      });
  }

  render() {
    const { id, label, showElem, value, isRequired, size, errorMessage, showError, optionValue } = this.props;
    return (
        <div className={size + " d-inline-block"} >
            <label className={isRequired ? "required" : ""}
                   htmlFor={id}
                   style={isRequired && showError ? {color: "red"} : {}}
            >
                {label}
            </label>
            <Field
                style={isRequired && showError ? {borderColor: "red"} : {}}
                id={id}
                className="form-control form-control-sm"
                component="select"
                name={id}
                value={value}
            >
                <option value="default" disabled>
                    --select one--
                </option>
                {this.state.options.map(option => {
                    return (
                        <option key={optionValue ? option[optionValue] : option[id]} value={optionValue ? option[optionValue] : option[id]}>
                            {option[showElem]}
                        </option>
                    );
                })}
            </Field>
            {errorMessage}
        </div>
    );
  }
}

export default SelectionFields;
